module.exports = __webpack_public_path__ + "static/media/delete.1afd3748.svg";